'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const iconsbyIds = require('../../node_modules/mlb-icons/json/iconsbyIds.js');
const icon_types = require('./icon.types.js');
const icon_style = require('./icon.style.js');
const universal_color = require('../../style/universal.color.js');
const styleOverrides = require('./utils/styleOverrides.js');
const buildSvg = require('./utils/buildSvg.js');
const generateId = require('../../utils/generateId.js');

var _excluded = ["allowColorOverride", "allowStyleOverride", "ariaLabel", "className", "description", "fallback", "fill", "name", "orientation", "role", "size", "width"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Icon = function Icon(_ref) {
  var _ref$allowColorOverri = _ref.allowColorOverride,
    allowColorOverride = _ref$allowColorOverri === void 0 ? true : _ref$allowColorOverri,
    _ref$allowStyleOverri = _ref.allowStyleOverride,
    allowStyleOverride = _ref$allowStyleOverri === void 0 ? true : _ref$allowStyleOverri,
    ariaLabel = _ref.ariaLabel,
    className = _ref.className,
    description = _ref.description,
    fallback = _ref.fallback,
    fill = _ref.fill,
    name = _ref.name,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 0 : _ref$orientation,
    role = _ref.role,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? icon_types.IconSizes.AUTO : _ref$size,
    width = _ref.width,
    props = _objectWithoutProperties(_ref, _excluded);
  var icon = iconsbyIds.default[name] || fallback && iconsbyIds.default[fallback];

  // If the icon wasn't found, don't return any
  if (!icon) {
    return null;
  }

  // Keep track of the size value for the svg building
  // as well as a string for the styling
  var sizeNum;
  var sizeStyle;
  if (width) {
    sizeNum = width;
    sizeStyle = "".concat(width, "px");
  } else {
    switch (size) {
      case icon_types.IconSizes.SM:
        sizeNum = 12;
        sizeStyle = "".concat(sizeNum, "px");
        break;
      case icon_types.IconSizes.MD:
        sizeNum = 16;
        sizeStyle = "".concat(sizeNum, "px");
        break;
      case icon_types.IconSizes.LG:
        sizeNum = 24;
        sizeStyle = "".concat(sizeNum, "px");
        break;
      default:
        sizeNum = 24;
        sizeStyle = "100%";
        break;
    }
  }
  var content = buildSvg(icon.children);

  // If we're overriding styles, use the specific wrapper for the icon (if it exists)
  var Wrapper = allowStyleOverride && styleOverrides.IconWrapperOverrides[name] || icon_style.IconWrapper;
  // If we're overriding colors, use the default color for the icon only if fill isn't passed.
  var useFill = fill || allowColorOverride && styleOverrides.IconColorOverrides[name] || universal_color.mlbGrey5;
  var _useRef = React.useRef(generateId("".concat(icon.id, "-"))),
    iconId = _useRef.current;
  return /*#__PURE__*/React__default.createElement(Wrapper, _extends({
    className: className,
    $sizeStyle: sizeStyle,
    fill: useFill,
    transform: "rotate(".concat(orientation, ")"),
    viewBox: "0 0 ".concat(sizeNum, " ").concat(sizeNum),
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#".concat(iconId)
  }, /*#__PURE__*/React__default.createElement("symbol", {
    xmlns: icon.attributes.xmlns,
    viewBox: icon.attributes.viewBox,
    id: "".concat(iconId),
    key: "".concat(iconId),
    role: role
  }, /*#__PURE__*/React__default.createElement("title", {
    id: "title-".concat(iconId)
  }, iconId), description && /*#__PURE__*/React__default.createElement("desc", {
    id: "desc-".concat(iconId)
  }, description), content)));
};

module.exports = Icon;
